import hash from "object-hash";

export const baseRule = {
  source: "MY.APPCUES",
  state: "DRAFT",
  published: false,
  shown: false,
  bookmarkId: null,
  domains: "",
  for: 0,
  when: 0,
  where: "/",
  whereHash: hash("/"),
  isRegex: false,
  languages: "",
  properties: null,
  frequency: "once",
  startDate: null,
  endDate: null,
  editing: false,
  nextContentId: null,
  redirectUrl: null,
  contentType: "journey"
};

export const SET_GOAL_ON_RULE = "SET_GOAL_ON_RULE";
export const CREATE_RULE = "CREATE_RULE";
